
<his-plam [hisDdKey]="ddKey" [label]="label" [showLabelTop]="showLabelTop">
	<p-autoComplete #content
		[hisDdKey]="ddKey"
		[(ngModel)]="value"
		[forceSelection]="true"
		[suggestions]="filteredBooleanTypes" 
		[dropdown]="true"
		field="text"
		(completeMethod)="filterBooleanTypes($event)"
		(onSelect)="onSelect($event.value)"
		(onClear)="onClear()"
		styleClass="{{styleClass}}"
		[disabled]="!editMode">
	</p-autoComplete>
</his-plam>
